const ShowingPasswordValidationText = () => {
  return (
    <div className='row mt-1 text-danger'>
      <span>* Password must be any 8-16 characters long.</span>
    </div>
  );
};

export default ShowingPasswordValidationText;
